import { createLogger } from "utils/logging";
import { addLoadedTracking, addMiniActionsToVisibilityChanges, cleanupExpirySchedulerMap, createExpirySchedulerMap, initBenefitExpiryCleanup } from "../utils";
import type { Debug } from "@otto-ec/global-resources/debug";
const log = createLogger("cinema", "module");

const PARENT_ID = "FT9-benefit-main";

export class Cinema {
	init(featureOrder: number) {
		log.info("Initialize cinema-module");

		const cinema = document.querySelector<HTMLOcCinemaV1Element>(`[data-module*=ft9-benefit-cinema]`);
		if (!cinema) {
			return log.info("no cinema found");
		}

		log.info("initialize first cinema found");

		/*                                                                                      */
		/*                                                                                             */
		cinema.addEventListener("tr-submit-tracking", ({ detail }) => {
			switch (true) {
				case detail.eventName === "tr-become-visible" && detail.method === "submitMiniAction":
					addMiniActionsToVisibilityChanges(detail, cinema, "scroll", PARENT_ID);
					break;
				case detail.eventName === "oc-item-visibility-changed" && detail.method === "submitMiniAction":
					if (detail.event.detail.scrollDirection === "left") {
						detail.abort();
						return;
					}
					log.info("cinema slide changed");
					addMiniActionsToVisibilityChanges(detail, cinema, "next", PARENT_ID);
					break;
				case detail.eventName === "tr-page-impression" && detail.method === "submitMerge":
					addLoadedTracking(detail, cinema, featureOrder, log as unknown as Debug<string>, PARENT_ID);
					break;
				default:
					break;
			}
		});

		const expirySchedulerMap = createExpirySchedulerMap(cinema);
		initBenefitExpiryCleanup(cinema, expirySchedulerMap);
		cinema.addEventListener("oc-unmount", () => {
			cleanupExpirySchedulerMap(expirySchedulerMap);
		});
	}
}
